import { AfterViewInit, Component, Input, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { ClassicEditor, EditorConfig, InlineEditor } from 'ckeditor5';

import { CkUploadAdapter } from '../../utils/ckeditor-uploader';
import { buildCkeditorConfig } from '../../utils/ckeditor.config';

@Component({
  selector: 'app-html-editor',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, CKEditorModule],
  templateUrl: './html-editor.component.html',
  styleUrl: './html-editor.component.scss',
})
export class HtmlEditorComponent implements AfterViewInit {

  private http = inject(HttpClient);

  /** Toggle del modo de edición: cuando hay formControl, el formulario manda */
  @Input() formControlEditing = new FormControl();

  /** Datos iniciales si no se usa formControl */
  @Input() data: string;

  /** Modo inline (true) vs Classic (false) */
  @Input() inline = false;

  public isLayoutReady = false;
  public editor: any;
  public editorConfig: EditorConfig;
  private editorInstance: { editing?: { view: { focus: () => void } } } | null = null;

  ngAfterViewInit(): void {
    this.editor = this.inline ? InlineEditor : ClassicEditor;
    if (this.data !== undefined) {
      this.formControlEditing.setValue(this.data);
    }
    this.editorConfig = buildCkeditorConfig();
    this.isLayoutReady = true;
  }

  /**
   * CKEditor llama a este handler cuando termina la inicialización; lo usamos
   * para enchufar el adapter de upload de imágenes contra el backend.
   */
  onEditorReady(editor: any): void {
    this.editorInstance = editor;
    editor.plugins.get('FileRepository').createUploadAdapter = (loader: any) =>
      new CkUploadAdapter(loader, this.http);
  }

  /** Necesario tras salir de modo lectura en diálogos Material (focus trap). */
  focusEditor(): void {
    queueMicrotask(() => this.editorInstance?.editing?.view?.focus());
  }
}
